<template>
  <div class="platform-account-modal">
    <a
      v-if="isSecondPage"
      href="javascript:void 0"
      class="platform-account-modal-back"
      @click="toHomePage"
    ></a>
    <a
      v-if="!isSecondPage"
      href="javascript:void 0"
      class="platform-account-modal-close"
      @click="close"
    ></a>
    <div v-if="curActiveTpl === 0" class="first">
      <p class="title has-tip color-theme">{{ title }}</p>
      <p class="tip color-theme">{{ titleTip }}</p>
      <div v-if="visibleSwitchPhone" class="content phone">
        <div class="icon-bg">
          <i class="iconfont icon-shouji"></i>
        </div>
        <div class="area-code">
          <Select v-model="phoneCodeValue">
            <option
              v-for="item in phoneCodeOptions"
              :key="item.value"
              :value="item.value"
              :disabled="disabledInput"
            >
              {{ item.label }}
            </option>
          </Select>
        </div>
        <Editor
          editorClass="editor-input phone-input"
          v-model="phoneValue"
          type="number"
          :disabled="disabledInput"
        >
        </Editor>
      </div>
      <div v-if="visibleSwitchEmail" class="content email">
        <div class="icon-bg">
          <em class="iconfont icon-youxiang"></em>
        </div>
        <Editor
          editorClass="editor-input"
          v-model="emailValue"
          :placeholder="languages.enterEmailTips"
          :disabled="disabledInput"
        >
        </Editor>
      </div>
      <div class="footer">
        <Button
          class="common-btn"
          :loading="loadingGetValidCode"
          @click="getValidCode"
        >
          {{ submitText }}
        </Button>
        <!-- <a
          v-if="visibleSwitchEmail && ph"
          href="javascript:;"
          class="footer-switch icon-bg"
          @click="switchPhoneInput"
        >
          <em class="iconfont icon-shouji"></em>
        </a>
        <a
          v-if="visibleSwitchPhone && em"
          href="javascript:;"
          class="footer-switch icon-bg"
          @click="switchEmailInput"
        >
          <em class="iconfont icon-youxiang"></em>
        </a> -->
      </div>
    </div>
    <div v-if="curActiveTpl === 1" class="second">
      <p class="title">{{ languages.editVrfCodeTips }}</p>
      <div class="content">
        <Editor
          class="content-editor"
          editorClass="editor-input"
          v-model="validCode"
        ></Editor>
        <p v-if="isPlatformAccountUnBind" class="content-item">
          {{ languages.canRebind }}
        </p>
        <SingleCheckbox
          v-if="!isPlatformAccountUnBind"
          class="content-item"
          :class="{ errorAnimate: showAgreeMentError }"
          v-bind:value.sync="agreeMent"
        >
          <span v-html="agreeItem" @click="openItem"></span>
        </SingleCheckbox>
        <!-- 只有首次绑定才展示 -->
        <SingleCheckbox
          v-if="
            visibleSwitchPhone ||
            (!isPlatformAccountUnBind && isPlatformAccountBind)
          "
          class="content-item"
          v-bind:value.sync="sendDiscount"
          >{{ languages.sendGameNews }}
        </SingleCheckbox>
        <Button
          class="common-btn content-item submit-bind"
          block
          :loading="loadingSubmitBind"
          @click="formalHandle"
        >
          {{ submitText }}
        </Button>
        <AcountDownBtn
          type="default"
          class="common-btn count-btn"
          :countText="languages.reGetVrfCode"
          :countTime="countTime"
          @countDown="getValidCode"
        >
          {{ languages.reGetVrfCode }}
        </AcountDownBtn>
      </div>
    </div>
    <div v-if="curActiveTpl === 2" class="third">
      <p v-if="visibleSwitchEmailAccount || visibleSwitchPhone" class="content">
        {{ errorPageTip }}
      </p>
      <p v-else class="content">{{ errorPageTipAnt }}</p>
      <div class="btns">
        <Button class="btns-item back" @click="backToReInput">
          {{ languages.back }}
        </Button>
        <Button
          v-if="visibleSwitchEmailAccount || visibleSwitchPhone"
          class="btns-item"
          :loading="loadingLogin"
          @click="errorHandle"
        >
          {{ errorPageConfirmBtnText }}
        </Button>
      </div>
    </div>
    <div v-if="curActiveTpl === 3" class="fourth">
      <div class="content">
        {{ succMsg }}
      </div>
      <div class="btns">
        <Button class="btns-item" @click="close">{{
          languages.confirm
        }}</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@utiles';
import { emailValidate } from '@store/officialPassport/validator';
import { TOST, HIDE_DIALOG } from '@store/dialog';
import {
  PAGE_INIT,
  UPDATE_PLATFORM_ACCOUNT_POPUP_VISIBLE,
  GET_PLATFORM_EMAIL_CODE,
  BIND_PLATFORM_EMAIL,
  BIND_PLATFORM_PHONE,
  GET_PLATFORM_BIND_INFO,
  DO_DEBIND,
  INIT_BIND_INFO,
  GET_CAN_DEBIND_TYPE,
  REFRESH_LOGIN_STATUS,
  GET_PLATFORM_PHONE_CODE
} from '@store/account';
import { SET_ORIGIN_USER_TYPE_ACTION } from '@store/passport/accountSetting';
import { encryption } from '@utiles/index';
import globalConfig from '@utiles/globalConfig';
import bridge from '@utiles/bridge';
import { ERR_CODE } from '@store/ultile';
import SingleCheckbox from '@components/passport/SingleCheckbox.vue';
import AcountDownBtn, {
  START_COUNT_DOWN_EVT,
  REET_STATUS
} from '@components/passport/AcountDownBtn.vue';
import { isAndroid } from '@utiles/device';

const typeOriginName = {
  fb: 'facebook',
  ap: 'apple',
  gp: 'google',
  hw: 'hw_login',
  ln: 'line',
  nv: 'naver',
  tw: 'twitter',
  vk: 'vk',
  gc: 'game_center',
  em: 'email',
  ph: 'phone'
};

export default {
  name: 'PlatformAccount',
  data() {
    return {
      visibleSwitchPhone: false,
      visibleSwitchEmail: false,
      curActiveTpl: 0,
      phoneValue: '',
      emailValue: '',
      phoneCodeValue: '60',
      phoneCodeOptions: [
        {
          label: '+60',
          value: 60
        },
        {
          label: '+65',
          value: 65
        },
        {
          label: '+63',
          value: 63
        },
        {
          label: '+62',
          value: 62
        },
        {
          label: '+66',
          value: 66
        },
        {
          label: '+84',
          value: 84
        },
        {
          label: '+86',
          value: 86
        },
        {
          label: '+886',
          value: 886
        },
        {
          label: '+852',
          value: 852
        },
        {
          label: '+853',
          value: 853
        },
        {
          label: '+61',
          value: 61
        },
        {
          label: '+81',
          value: 81
        },
        {
          label: '+1',
          value: 1
        },
        {
          label: '+82',
          value: 82
        },
        {
          label: '+856',
          value: 856
        },
        {
          label: '+64',
          value: 64
        },
        {
          label: '+966',
          value: 966
        },
        {
          label: '+855',
          value: 855
        },
        {
          label: '+971',
          value: 971
        },
        {
          label: 'Other',
          value: 0
        }
      ],
      countTime: 60, // 获取验证码倒计时是60s
      validCode: '',
      agreeMent: false,
      sendDiscount: false,
      succMsg: '',
      loadingGetValidCode: false,
      loadingSubmitBind: false,
      disabledGetValidCode: false,
      showAgreeMentError: false,
      loadingLogin: false,
      disabledInput: false,
      // 蚂蚁绑定无登录错误提示
      errorPageTipAnt: ''
    };
  },
  watch: {
    platformAccountType: {
      handler(val) {
        if (val === 'em') {
          this.switchEmailInput();
          return;
        }
        if (val === 'ph') {
          this.switchPhoneInput();
          return;
        }
      },
      immediate: true
    },
    isOpenUnbindPopup: {
      async handler(newVal) {
        if (!newVal) return;
        let kind = '';
        if (this.visibleSwitchEmail) {
          kind = 'email';
        }
        if (this.visibleSwitchPhone) {
          kind = 'phone';
        }
        try {
          const res = await this.$store.dispatch(GET_PLATFORM_BIND_INFO, kind);
          if (res?.result == 1) {
            this.disabledInput = true;
            // 自动填充绑定的邮箱或是手机
            if (this.visibleSwitchEmail) {
              this.emailValue = res?.data?.EMAIL || undefined;
            }
            if (this.visibleSwitchPhone) {
              this.phoneCodeValue = res?.data?.PHONE_CODE
                ? String(res?.data?.PHONE_CODE)
                : '60';
              this.phoneValue = res?.data?.PHONE || undefined;
            }
          }
        } catch (err) {
          console.error(err);
        }
      },
      immediate: true
    }
  },
  computed: {
    visibleSwitchEmailAccount() {
      return this.$store.state.account.visibleSwitchEmailAccount;
    },
    isOpenUnbindPopup() {
      return (
        this.$store.state.account.isPlatformAccountUnBind &&
        this.$store.state.account.visiblePlatformAccountPopup
      );
    },
    agreeItem() {
      let agreePlatform = this.languages.agreePlatform;
      agreePlatform = agreePlatform.replace(
        '\${service}',
        `<a href="javascript:;" class="agree-item" data-itemType="service">${this.languages.termsOfUse}</a>`
      );
      agreePlatform = agreePlatform.replace(
        '\${privite}',
        `<a href="javascript:;" class="agree-item" data-itemType="privite">${this.languages.privacyPolicy}</a>`
      );
      return agreePlatform;
    },
    platformAccountType() {
      return this.$store.state.account.platformAccountType;
    },
    title() {
      if (this.isPlatformAccountUnBind) {
        return this.languages.debindText;
      }
      if (this.isPlatformAccountBind) {
        // 绑定标题
        if (this.visibleSwitchEmail) {
          return this.languages.emailAccount;
        }
        if (this.visibleSwitchPhone) {
          return this.languages.phoneAccount;
        }
        return '';
      } else {
        // 登录标题
        if (this.visibleSwitchEmail) {
          return this.languages.emailAccount;
        }
        if (this.visibleSwitchPhone) {
          return this.languages.phoneAccount;
        }
        return '';
      }
    },
    titleTip() {
      if (this.isPlatformAccountUnBind) {
        if (this.visibleSwitchEmail) {
          return this.languages.canNotBindEmail;
        }
        if (this.visibleSwitchPhone) {
          return this.languages.canNotBindPhone;
        }
        return '';
      }
      if (this.isPlatformAccountBind) {
        if (this.visibleSwitchEmail) {
          return this.languages.canChangeByEmail;
        }
        if (this.visibleSwitchPhone) {
          return this.languages.canChangeByPhone;
        }
        return '';
      }
    },
    languages() {
      return this.$store.state.passport.languages;
    },
    isSecondPage() {
      return this.curActiveTpl === 1;
    },
    isFourthPage() {
      return this.curActiveTpl === 3;
    },
    submitText() {
      if (this.isPlatformAccountUnBind) {
        return this.languages.debindText;
      }
      return this.isPlatformAccountBind
        ? this.languages.bindCommon
        : this.languages.newVipLogin;
    },
    errorPageTip() {
      if (this.isPlatformAccountBind) {
        // 绑定
        if (this.visibleSwitchEmail) {
          return this.languages.emailHadBind; // 该邮箱账号已被绑定，是否直接登录
        }
        if (this.visibleSwitchPhone) {
          return this.languages.phoneHadBind; // 该手机号账号已被绑定，是否直接登录
        }
      } else {
        // 登录
        if (this.visibleSwitchEmail) {
          return this.languages.emailNotBind; // 该邮箱帐号未绑定，是否创建新账号
        }
        if (this.visibleSwitchPhone) {
          return this.languages.phoneNotBind; // 该手机号账号未绑定，是否创建新账号
        }
      }
    },
    errorPageConfirmBtnText() {
      return this.isPlatformAccountBind
        ? this.languages.newVipLogin // 登录
        : this.languages.registerNewAccount; // 注册新账号
    },
    em() {
      return this.$store.state.account.bindSupportArr.includes('em');
    },
    ph() {
      return this.$store.state.account.bindSupportArr.includes('ph');
    },
    isPlatformAccountBind() {
      return this.$store.state.account.isPlatformAccountBind;
    },
    isPlatformAccountUnBind() {
      return this.$store.state.account.isPlatformAccountUnBind;
    }
  },
  methods: {
    openItem(e) {
      const dataset = e?.target?.dataset;
      const mainHost = globalConfig.getMainHost();
      let url = '';
      if (dataset?.itemtype === 'service') {
        url = `https://gpassport.${mainHost}/center/ServicePrivacy/service`;
      }
      if (dataset?.itemtype === 'privite') {
        url = `https://gpassport.${mainHost}/center/ServicePrivacy/privacy`;
      }
      if (url === '') {
        return;
      }
      bridge.callSdkMethod('openWebView', {
        url: url,
        loginDir: 0, // 0不需要登录跳转，1 需要登录跳转
        appendParams: 0 // 0不需要添加统一参数，1 需要添加统一参数
      });
    },
    // 关闭弹窗
    closeModal() {
      if (this.isFourthPage) {
        this.$store.dispatch(HIDE_DIALOG);
      }
      this.$store.commit(UPDATE_PLATFORM_ACCOUNT_POPUP_VISIBLE, false);
      this.resetData();
    },
    // 重置数据
    resetData() {
      this.curActiveTpl = 0;
      this.phoneValue = undefined;
      this.emailValue = undefined;
      this.validCode = undefined;
      this.agreeMent = false;
      this.sendDiscount = false;
      this.succMsg = '';
      this.loadingGetValidCode = false;
      this.loadingSubmitBind = false;
      this.disabledGetValidCode = false;
      this.showAgreeMentError = false;
      this.loadingLogin = false;
      this.disabledInput = false;
    },
    // 返回手机或者邮箱输入页面
    toHomePage() {
      this.curActiveTpl = 0;
    },
    // 去验证码输入页面
    toValidCodePage() {
      this.curActiveTpl = 1;
    },
    // 去错误信息提示页面
    toErrorPage() {
      this.curActiveTpl = 2;
    },
    // 去成功信息提示页面
    toSuccessPage(succMsg) {
      this.succMsg = succMsg;
      this.curActiveTpl = 3;
    },
    // 返回重新输入
    backToReInput() {
      if (this.visibleSwitchPhone) {
        this.phoneValue = undefined;
      }
      if (this.visibleSwitchEmail) {
        this.emailValue = undefined;
      }
      this.validCode = undefined;
      EventBus.$emit(REET_STATUS);
      this.toHomePage();
    },
    // 完成登录或绑定关闭
    close() {
      this.closeModal();
      this.resetData();
    },
    switchPhoneInput() {
      this.visibleSwitchEmail = false;
      this.visibleSwitchPhone = true;
    },
    switchEmailInput() {
      this.visibleSwitchPhone = false;
      this.visibleSwitchEmail = true;
    },
    // 校验邮箱
    validEmail() {
      if (emailValidate(this.emailValue)) {
        return true;
      }
      this.$store.dispatch(TOST, this.languages.emailVAlidateMsg);
      return false;
    },
    // 校验手机号
    validPhone() {
      if (this.phoneValue && this.phoneValue.trim().length > 0) {
        return true;
      }
      this.$store.dispatch(TOST, this.languages.phoneInputError);
      return false;
    },
    // 获取验证码
    getValidCode() {
      if (this.visibleSwitchPhone) {
        if (!this.validPhone()) return;
        this.getValidPhoneCode();
        return;
      }
      if (this.visibleSwitchEmail) {
        if (!this.validEmail()) return;
        this.getValidEmailCode();
        return;
      }
    },
    // 获取手机验证码
    async getValidPhoneCode() {
      const submitParams = {
        phone: this.phoneValue,
        phoneCode: this.phoneCodeValue,
        actionKind: this.isPlatformAccountUnBind ? 'unbind' : 'login_bind'
      };
      this.loadingGetValidCode = true;
      try {
        await this.$store.dispatch(GET_PLATFORM_PHONE_CODE, submitParams);
        this.toValidCodePage();
        this.$nextTick(() => {
          this.countValidCode();
        });
      } catch (err) {
        console.log(err);
        this.$store.dispatch(TOST, this.languages.frequently);
      }
      this.loadingGetValidCode = false;
    },
    // 获取邮箱验证码
    async getValidEmailCode() {
      const submitParams = {
        email: this.emailValue,
        actionKind: this.isPlatformAccountUnBind ? 'unbind' : 'login_bind'
      };
      this.loadingGetValidCode = true;
      try {
        await this.$store.dispatch(GET_PLATFORM_EMAIL_CODE, submitParams);
        this.toValidCodePage();
        this.$nextTick(() => {
          this.countValidCode();
        });
      } catch (err) {
        console.log(err);
        this.$store.dispatch(TOST, this.languages.frequently);
      }
      this.loadingGetValidCode = false;
    },
    beforeSubmitCheck() {
      return new Promise(resolve => {
        if (this.showAgreeMentError) {
          resolve(false);
          return;
        }
        // 是否同意条款
        if (!this.agreeMent && !this.isPlatformAccountUnBind) {
          this.showAgreeMentError = true;
          setTimeout(() => {
            this.showAgreeMentError = false;
          }, 1000);
          resolve(false);
          return;
        }
        // 校验验证码是否填写
        if (!this.validCode) {
          this.$store.dispatch(TOST, this.languages.inputCkCode);
          resolve(false);
          return;
        }
        resolve(true);
      });
    },
    // 开始验证码倒计时
    countValidCode() {
      EventBus.$emit(START_COUNT_DOWN_EVT);
    },
    // 正常处理
    async formalHandle() {
      const rs = await this.beforeSubmitCheck();
      if (!rs) return;
      if (this.isPlatformAccountUnBind) {
        this.unbind();
        return;
      }
      this.isPlatformAccountBind ? this.bind() : this.login();
    },
    // 异常处理
    async errorHandle() {
      const rs = await this.beforeSubmitCheck();
      if (!rs) return;
      this.login(true);
    },
    // 解除绑定
    unbind() {
      // 提交绑定
      if (this.visibleSwitchPhone) {
        this.carryUnBind('ph');
        return;
      }
      if (this.visibleSwitchEmail) {
        this.carryUnBind('em');
        return;
      }
    },
    // 解绑邮箱/手机
    async carryUnBind(curType) {
      try {
        this.loadingSubmitBind = true;
        let submitParams = null;
        if (this.visibleSwitchEmail) {
          submitParams = {
            email: decodeURIComponent(encryption(this.emailValue))
          };
        }
        if (this.visibleSwitchPhone) {
          submitParams = {
            phoneCode: this.phoneCodeValue,
            phone: decodeURIComponent(encryption(this.phoneValue))
          };
        }
        const resDebind = await this.$store.dispatch(
          DO_DEBIND,
          Object.assign(
            {
              code: this.validCode,
              uid: globalConfig.getHrefParam('userId') || ''
            },
            this.getDebindActionParam(curType),
            submitParams
          )
        );
        this.toSuccessPage(this.languages.unbindSucc);
        this.updateDebindType();
        const resBindInfo = await this.$store.dispatch(INIT_BIND_INFO);
        const sdkParams = {
          msg: resDebind.msg,
          type: curType === 'em' ? 'email' : 'phone',
          data: {
            IS_BIND_THIRD: resBindInfo?.data?.data?.IS_BIND_THIRD || 0, // 是否已绑定第三方,1已绑定, 0未绑定
            IS_BIND_EMAIL: resBindInfo?.data?.data?.IS_BIND_EMAIL || 0, // 邮箱绑定状态, 1已绑定, 0未绑定
            IS_BIND_PHONE: resBindInfo?.data?.data?.IS_BIND_PHONE || 0 // 手机号绑定状态, 1已绑定, 0未绑定
          }
        };
        // TODO:告诉SDK解绑成功
        bridge.callSdkMethod('syncPlatformIDBindInfo', sdkParams);
        this.handleAndroidLogout(curType);
      } catch (err) {
        console.log(err);
        this.$store.dispatch(
          TOST,
          err?.res?.data?.msg || this.languages.unbindFail
        );
        this.updateDebindType();
      }
      this.loadingSubmitBind = false;
    },
    async bind(isErrorHandle) {
      let way = '';
      let action = '';
      let bindErrorCode = '';
      let submitParams = null;

      // 提交绑定
      if (this.visibleSwitchPhone) {
        /**
         * 验证手机是否被绑定：
         * 登录：如果手机未被绑定了：返回的错误码：-901301
         * 绑定时：如果手机已经被绑定，返回的错误码：-901302
         */
        way = 'ph';
        action = BIND_PLATFORM_PHONE;
        bindErrorCode = '-901302';
        submitParams = {
          phone: this.phoneValue,
          phoneCode: this.phoneCodeValue,
          code: this.validCode,
          sendDiscount: this.sendDiscount ? 'agree' : 'disagree',
          checkIsBind: isErrorHandle ? 0 : 1 // 传入1校验是否已绑定
        };
      }
      if (this.visibleSwitchEmail) {
        /**
         * 验证邮箱是否被绑定：
         * 登录：如果邮箱未被绑定了：返回的错误码：-901201
         * 绑定时：如果邮箱已经被绑定，返回的错误码：-901202
         */
        way = 'em';
        action = BIND_PLATFORM_EMAIL;
        bindErrorCode = '-901202';
        submitParams = {
          email: this.emailValue,
          code: this.validCode,
          sendDiscount: this.sendDiscount ? 'agree' : 'disagree',
          checkIsBind: isErrorHandle ? 0 : 1 // 传入1校验是否已绑定
        };
      }

      try {
        this.loadingSubmitBind = true;
        const res = await this.$store.dispatch(action, submitParams);
        this.updateDebindType();
        const sdkParams = {
          msg: res?.msg,
          type: way === 'em' ? 'email' : 'phone',
          data: {
            IS_BIND_THIRD: res?.data?.IS_BIND_THIRD || 0, // 是否已绑定第三方,1已绑定, 0未绑定
            IS_BIND_EMAIL: res?.data?.IS_BIND_EMAIL || 0, // 邮箱绑定状态, 1已绑定, 0未绑定
            IS_BIND_PHONE: res?.data?.IS_BIND_PHONE || 0 // 手机号绑定状态, 1已绑定, 0未绑定
          }
        };
        bridge.callSdkMethod('syncPlatformIDBindInfo', sdkParams);
        // 3、重新调用SDK初始化接口
        this.$store.dispatch(PAGE_INIT, false);
        this.toSuccessPage(this.languages.eventSuccBind);
        // 绑定成功打点
        window?.passportv2DataLayer?.push({
          eventName: 'bind_sns',
          eventValue: '', // 成功留空
          eventType: typeOriginName[way],
          eventReason: '绑定成功'
        });
      } catch (err) {
        console.log(err);
        if (isErrorHandle) {
          this.$store.dispatch(TOST, err?.msg);
        } else {
          // 已被绑定
          if (err?.code == bindErrorCode) {
            this.errorPageTipAnt = err?.msg || err?.code || 'fail';
            this.toErrorPage();
            return;
          }
          this.$store.dispatch(TOST, err?.msg);
        }
        window?.passportv2DataLayer?.push({
          eventName: 'bind_sns',
          eventValue: { code: err?.code, msg: err?.msg },
          eventType: typeOriginName[way],
          eventReason: '绑定失败'
        });
      }
      this.loadingSubmitBind = false;
    },
    login(isErrorHandle) {
      let bindErrorCode = '';
      let submitParams = null;

      if (this.visibleSwitchPhone) {
        /**
         * 验证手机是否被绑定：
         * 登录：如果手机未被绑定了：返回的错误码：-901301
         * 绑定时：如果手机已经被绑定，返回的错误码：-901302
         */
        bindErrorCode = '-901301';
        submitParams = {
          type: 'ph',
          account: this.phoneValue,
          code: this.validCode,
          phoneCode: this.phoneCodeValue,
          isSubGameNews: this.sendDiscount ? 1 : 0
        };
      }
      if (this.visibleSwitchEmail) {
        /**
         * 验证邮箱是否被绑定：
         * 登录：如果邮箱未被绑定了：返回的错误码：-901201
         * 绑定时：如果邮箱已经被绑定，返回的错误码：-901202
         */
        bindErrorCode = '-901201';
        submitParams = {
          type: 'em',
          account: this.emailValue,
          code: this.validCode,
          phoneCode: ''
        };
      }

      this.loadingLogin = true;
      const _self = this;

      window.loginSdkHandle = async function (res) {
        // 失败的操作
        if (res?.result == ERR_CODE) {
          if (isErrorHandle) {
            _self.$store.dispatch(TOST, res?.msg);
          } else {
            // 未绑定
            if (res?.data?.error_code == bindErrorCode) {
              _self.toErrorPage();
            } else {
              _self.$store.dispatch(TOST, res?.msg);
            }
          }
          _self.loadingLogin = false;
          return;
        }

        // 成功的操作
        // 1、刷新用户信息
        await _self.$store.dispatch(REFRESH_LOGIN_STATUS).catch(err => {
          _self.$store.dispatch(TOST, err);
        });
        // 2、更新originType
        _self.$store.dispatch(SET_ORIGIN_USER_TYPE_ACTION, { typeId: 0 });
        _self.toSuccessPage(_self.languages.loginSucc);
        _self.loadingLogin = false;
      };

      bridge.callSdkMethod('switchAccount', {
        ...submitParams,
        checkIsBind: isErrorHandle ? 0 : 1,
        callback: 'loginSdkHandle',
        isSubGameNews: this.sendDiscount ? 1 : 0
      });
    },
    getDebindActionParam(type) {
      return {
        gameId: globalConfig.getHrefParam('gameId') || '',
        packageName: globalConfig.getHrefParam('packageName') || '',
        devicePlate: globalConfig.getHrefParam('devicePlate') || '',
        androidid: globalConfig.getHrefParam('androidid') || '',
        idfa: globalConfig.getHrefParam('idfa') || '',
        gpid: globalConfig.getHrefParam('gpid') || '',
        unbindType: typeOriginName[type],
        type: type
      };
    },
    updateDebindType() {
      this.unBindState &&
        !this.isH5 &&
        this.$store.dispatch(GET_CAN_DEBIND_TYPE, {
          gameId: globalConfig.getHrefParam('gameId') || '',
          packageName: globalConfig.getHrefParam('packageName') || '',
          devicePlate: globalConfig.getHrefParam('devicePlate') || '',
          androidid: globalConfig.getHrefParam('androidid') || '',
          idfa: globalConfig.getHrefParam('idfa') || '',
          gpid: globalConfig.getHrefParam('gpid') || ''
        });
    },
    // 针对无自动登录版本的android，当前登录方式与解绑一样时，调用sdk退出登录接口，回到游客登录
    handleAndroidLogout(curType) {
      if (!isAndroid()) {
        return;
      }
      let thirdPlatForm = globalConfig.getHrefParam('thirdPlatForm') || '';
      if (!thirdPlatForm || thirdPlatForm === 'auto_login') {
        return;
      }
      const thirdPlatFormMap = {
        fb: 'fb',
        gp: 'google',
        hw: 'huawei',
        ln: 'line',
        nv: 'naver',
        tw: 'tw',
        vk: 'vk',
        em: 'em',
        ph: 'ph'
      };
      if (
        thirdPlatFormMap[curType] &&
        thirdPlatFormMap[curType] === thirdPlatForm
      ) {
        bridge.callSdkMethod('logout', {});
      }
    }
  },
  components: {
    SingleCheckbox,
    AcountDownBtn
  }
};
</script>

<style lang="scss" scoped>
.platform-account-modal {
  overflow: auto;
  position: relative;
  width: 510px;
  max-height: 100%;
  padding-bottom: 22px;
  background-color: #efeef1;

  &-back {
    position: absolute;
    top: 24px;
    left: 24px;
    width: 10px;
    height: 17px;
    padding: 10px;
    background: url('../../assets/image/passport/back.png') no-repeat
      center/10px 17px;
  }

  &-close {
    position: absolute;
    top: 24px;
    right: 24px;
    width: 20px;
    height: 20px;
    background: url('../../assets/image/passport/close.png') no-repeat
      center/contain;
  }

  .title {
    padding-top: 50px;
    font-size: 24px;
    text-align: center;
  }
  .tip {
    margin-bottom: 30px;
    font-size: 18px;
    text-align: center;
    color: #474747;
  }
  .content {
    margin-bottom: 20px;
    font-size: 26px;
  }
  .footer {
    &-switch {
      margin: 60px auto 0;
    }
  }

  .common-btn {
    display: block;
    width: 460px;
    height: 78px !important;
    font-size: 22px !important;
    margin: auto;
    font-size: 26px;
  }

  ::v-deep .editor-input {
    width: 374px !important;
    height: 78px !important;
    margin: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    font-size: 22px !important;
    &.phone-input {
      width: auto !important;
    }
  }

  .first {
    .title {
      margin-bottom: 22px;
    }
    .content {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 460px;
      height: 78px;
      margin: auto;
      background-color: #ffffff;
    }
    .email {
      .icon-bg {
        width: 64px;
        height: 100%;

        .icon-youxiang {
          width: 38px;
          height: 38px;
          background: url('../../assets/image/passport/em.png') no-repeat
            center/22px 17px;
          background-color: #57d397;
          border-radius: 50%;
        }
      }
    }
    .phone {
      .icon-bg {
        width: 64px;
        height: 100%;

        .icon-shouji {
          width: 38px;
          height: 38px;
          background: url('../../assets/image/passport/ph.png') no-repeat
            center/19px 29px;
          background-color: #57d397;
          border-radius: 50%;
        }
      }
      .area-code {
        border-right: 1px solid #474747;
        margin-right: 12px;
        ::v-deep .ocean-ui-select {
          border: 0 !important;
          font-size: 22px !important;
          color: #000000 !important;
        }
        ::v-deep .ocean-ui-form-select {
          padding: 0 1vh;
        }
      }
    }
    .footer {
      margin-top: 16px;
    }
  }

  .second {
    .title {
      margin-bottom: 46px;
    }
    .content {
      &-editor {
        display: block;
        text-align: center;
        margin-bottom: 24px;

        ::v-deep .editor-input {
          width: 460px !important;
          text-align: center;
          letter-spacing: 10px;
        }
      }
      &-item {
        display: block;
        width: 460px;
        margin: 0 auto 24px;
        font-size: 18px;
        color: #474747;

        &.submit-bind {
          margin-bottom: 24px;
        }
      }
      ::v-deep .input {
        font-size: 30px;
        text-align: center;
      }
    }
    .count-btn {
      ::v-deep .accountEmitor,
      ::v-deep .countDownBtn {
        box-sizing: border-box;
        font-size: 22px !important;
        border: 1px solid #d4d5d4 !important;
        background-color: #fff !important;
        color: #474747 !important;
      }
    }
    ::v-deep .agree-item {
      margin: 0 2px;
      color: #474747;
      text-decoration: underline;
    }
  }

  .third,
  .fourth {
    .btns {
      display: flex;
      justify-content: center;
      width: 460px;
      margin: auto;
      gap: 22px;

      &-item {
        box-sizing: border-box;
        flex: 1;
        height: 78px !important;
        font-size: 22px !important;

        &.back {
          border: 1px solid #d4d5d4 !important;
          background-color: #fff !important;
          font-size: 22px !important;
          color: #474747 !important;
        }
      }
    }
    .content {
      padding-top: 50px;
      margin-bottom: 60px;
      font-size: 20px;
      text-align: center;
    }
  }

  .icon-bg {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    height: 64px;
    background-color: var(--main-color);
    border-radius: 50%;
    > .iconfont {
      font-size: 40px;
      color: #ffffff;
    }
  }
  .area-code {
    border-right: 3px solid var(--text-color);
    ::v-deep .select {
      width: 100px;
      height: auto;
      padding: 0 20px;
    }
    ::v-deep .select-arrow {
      display: none;
    }
  }
}

.is-blancozone {
  .platform-account-modal {
    border-radius: 12px;

    ::v-deep .editor-input {
      background-color: transparent;
    }

    .common-btn {
      background-image: linear-gradient(to bottom, #c0dffd, #9dc7f1);
      border-radius: 78px * 0.5 !important;
    }
    .first {
      .content {
        box-sizing: border-box;
        border: 2px solid #c4d8ec;
        background-color: transparent;
        border-radius: 8px;
      }
      .icon-bg {
        .icon-youxiang,
        .icon-shouji {
          background-color: #9dcdfc;
        }
      }
    }
    .second {
      .content {
        ::v-deep .editor-input {
          border: 2px solid #c4d8ec;
          border-radius: 8px;
        }
      }
      .count-btn {
        ::v-deep .accountEmitor,
        ::v-deep .countDownBtn {
          box-sizing: border-box;
          height: 78px !important;
          border-radius: 78px * 0.5 !important;
        }
      }
    }
    .third {
      .btns {
        &-item {
          background-color: #9ecdfb !important;
          border-radius: 78px * 0.5 !important;

          &.back {
            border: 1px solid #d4d5d4 !important;
            background-color: #fff !important;
            background-image: none !important;
            color: #474747 !important;
          }
        }
      }
    }
    .fourth {
      .btns {
        &-item {
          background-image: linear-gradient(to bottom, #c0dffd, #9dc7f1);
          border-radius: 78px * 0.5 !important;
        }
      }
    }
  }
}
</style>
